/****   request.js   ****/
// 导入axios
import axios from "axios";
import store from "@/vuex/store";
import {
  loginPot,
  behaviorlogin
} from "@/api/apiPot";
// 使用element-ui Message做消息提醒
import {
  Message
} from "element-ui";
import md5 from 'js-md5';
// import { getToken } from "@/utils/auth";
import {
  getPotToken,
  setPotToken
} from "@/utils/auth";
import {
  getToken
} from "@/utils/auth";
//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口
  baseURL: "http://point.hfyego.com.cn/", //线上数据库
  // baseURL: "http://192.168.1.252:37807/", //线上数据库
  // baseURL : 'http://192.168.1.111:82/', // 测试服务器地址
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 20 * 1000
});
// 2.请求拦截器
// http request 拦截器
service.interceptors.request.use(
  config => {
    if (getPotToken()) {
      //判断token是否存在
      config.headers.Authorization = 'Bearer ' + getPotToken(); //将token设置成请求头
    }
    console.log('config:', config);
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

service.interceptors.request.use(
  config => {
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    // config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换
    config.headers = {
      "Content-Type": "application/json;charset=UTF-8" //配置请求头
    };
    //注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
    // config.headers.Authorization=getToken()

    const timestamp = Math.floor(Date.now() / 1000);
    config.data.timestamp = timestamp
    config.data.appkey = 'yunYingFenXixShop'
    config.data.method = config.method.toUpperCase()

    const queryParams = Object.entries(config.data)
      .sort()
      .map(([key, value]) => `${encodeURIComponent(key)}=${md5(encodeURIComponent(value))}`)
      .join("&");
    const str = encodeURIComponent(queryParams)

    config.headers.sign = md5(str).toUpperCase()
    config.headers.timestamp = timestamp
    config.headers.type = 'pc'
    delete config.data.timestamp
    delete config.data.appkey
    delete config.data.method
    return config;

    // const token = getCookie("名称"); //这里取token之前，你肯定需要先拿到token,存一下

    // if (token) {
    //   config.params = { token: token }; //如果要求携带在参数中
    //   config.headers.token = token; //如果要求携带在请求头中
    // }
    // return config;
  },
  error => {
    Promise.reject(error);
  }
);
var code = 1
// 3.响应拦截器
service.interceptors.response.use(
  response => {
    //接收到响应数据并成功后的一些共有的处理，关闭loading等
    let res = response.data; // 取到响应返回的数据
    if (res.code == 200) {
      // 可能需要返回一些操作成功，删除成功之类的提示，所以把整个信息返回，回调中取得时候记得加一层data
      return res;
    } else {
      if (getToken() && res.code == 401 && res.msg === "您还未登录") {
        if (code > 1) {
          return
        }
        code = 2
        // Message.error(res.msg);log
        loginPot({
            name: sessionStorage.getItem('userName')
          })
          .then(res => {
            const data = res.data;
            // setToken(data.token); //存储token
            // setUserInfo(commit, data.user); //存储用户信息
            // commit("SET_TOKEN", data.token);
            store.state.token = data.token;
            setPotToken(data.token); //存储token
            // commit("app/SET_INDEX_POP_STATE", 0, { root: true });
            // console.log('getPotToken12', getPotToken());
            setTimeout(() => {
              behaviorlogin({
                ip: localStorage.getItem('ipAddress'),
                login_device_name:localStorage.getItem('login_device_name'),
                login_device_id:localStorage.getItem('login_device_id'),
                inlet_index: '登入',
                login_device: 3
              }).then(() => {
                code = 1
              });
            }, 1000)
            // resolve(data);
          })
          .catch(error => {
            console.log('error', error);
          });
        // window.vm.$noLogin();
      } else {
        // 状态码如果不是200则为报错，弹出报错信息，且不返回任何数据
        /*   return Promise.reject(new Error(res || 'Error'))*/
        return Promise.reject(res.msg);
      }
    }
    /*  return response*/
  },
);
//4.导入文件
export default service;



// WEBPACK FOOTER //
// ./src/utils/requestPot.js